import React, { useState, useEffect } from "react";
import { setTitle } from "../helpers/MetaTag";
import toastr from "toastr";
import Searching from "../components/Searching";
import NoDataFound from "../components/NoDataFound";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import { MAIN_LOGO } from "../constant/Constant";
import Image from "../components/elements/Image";

const Callback = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Callback"
  );
  let navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const code = new URLSearchParams(window.location.search).get("code");
  const [loading, setLoading] = useState(true);
  const [isCheck, setIsCheck] = useState(1);
  const [reminderMinutesBeforeStart, setReminderMinutesBeforeStart] =
    useState(1);
  const [accessToken, setAccessToken] = useState("");

  const reminderId = localStorage.getItem("reminderId");
  const reminderDate = localStorage.getItem("reminderDate");
  const reminderFiled = localStorage.getItem("reminderFiled");

  const currentTime = new Date();
  const hours = ("0" + currentTime.getHours()).slice(-2);
  const minutes = ("0" + currentTime.getMinutes()).slice(-2);
  const seconds = ("0" + currentTime.getSeconds()).slice(-2);
  const time = `${hours}:${minutes}:${seconds}`;

  useEffect(() => {
    const getOutlookOauth2User = async () => {
      setLoading(true);
      try {
        const result = await postData("get-outlook-oauth2-user", {
          code: code,
        });
        if (result.status && result.status === 200) {
          setAccessToken(result?.data);
        } else {
          setLoading(false);
          console.log("result.message", result.message);
          toastr.error(result.message);
        }
      } catch (error) {
        console.log("error.message", error.message);
        toastr.error(error.message);
      }
    };
    if (code) {
      getOutlookOauth2User();
    }
  }, [code]);

  useEffect(() => {
    const createReminder = async () => {
      setLoading(true);
      try {
        const result = await postData("successor/update", {
          id: reminderId,
          [reminderFiled]: reminderDate,
        });
        if (result.status && result.status === 200) {
          const eventDetails = {
            subject: "Reminder for " + result?.data?.name,
            start: {
              dateTime: reminderDate + "T" + time,
              timeZone: "UTC",
            },
            end: {
              dateTime: reminderDate + "T" + time,
              timeZone: "UTC",
            },
            body: {
              contentType: "Text",
              content:
                "Please remember to prepare the successionnow development plan.",
            },
          };

          // Make POST request to create the event
          axios
            .post("https://graph.microsoft.com/v1.0/me/events", eventDetails, {
              headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              toastr.success("Reminder successfully added");
              localStorage.removeItem("reminderId");
              localStorage.removeItem("reminderDate");
              localStorage.removeItem("reminderFiled");
              return navigate("/development-plan");
            })
            .catch((error) => {
              toastr.error(error.response.data);
            });
        } else {
          toastr.error(result.message);
          setLoading(false);
        }
      } catch (error) {
        toastr.error(error.message);
      }
    };
    if (accessToken) {
      createReminder();
    }
  }, [accessToken]);

  return (
    <div className="w-full min-h-screen flex justify-center items-center bg-slate-100 py-10">
      <div className="w-full max-w-sm">
        <Link to={"/"}>
          <div className="h-14 w-full flex justify-center object-contain mb-5">
            <Image
              src={MAIN_LOGO}
              alt={""}
              width={"100%"}
              height={"100%"}
              classes={"object-contain object-center"}
            />
          </div>
        </Link>
        <div className="w-full bg-white rounded shadow-md py-8 px-6">
          {
            isCheck && isCheck === 1 && (
              <div className="divide-y divide-slate-200 space-y-4">
                {loading ? (
                  <Searching label={"Loading..."} />
                ) : (
                  <NoDataFound label={t("no_data_found")} />
                )}
              </div>
            )
            // :
            // (isCheck && isCheck === 2)?
            // <div className="divide-y divide-slate-200 space-y-4">
            //   <div className="relative">
            //       <h1 className="text-xl font-semibold text-center text-slate-700">
            //       {t('create_a_password')}
            //       </h1>
            //       <div className="text-sm text-slate-400 text-center font-light">
            //       {t('welcome_to_succession_now_please_create_your_password')}
            //       </div>
            //   </div>
            //   <div className="pt-4 space-y-4">
            //       <div className="relative">
            //           <Input
            //               label={t('password')}
            //               labelClasses={"!text-xs"}
            //               inputType={"password"}
            //               inputPlaceholder={t('your_password')}
            //               inputValue={password}
            //               setInput={setPassword}
            //               //errorType={''}
            //           />
            //       </div>
            //       <div className="relative">
            //           <Input
            //               label={t("confirm_password")}
            //               labelClasses={"!text-xs"}
            //               inputType={"password"}
            //               inputPlaceholder={t('your_password')}
            //               inputValue={confirmPassword}
            //               setInput={setConfirmPassword}
            //               //errorType={''}
            //           />
            //       </div>
            //       <div className="relative flex justify-center">
            //         <Button
            //           buttonClasses=""
            //           buttonLabelClasses=""
            //           buttonType={"button"}
            //           buttonIcon={(isChangePassword)?"fa-light fa-spinner fa-spin":"fa-light fa-arrow-right-to-arc"}
            //           buttonIconPosition={"left"}
            //           buttonLabel={t('save_password')}
            //           functions={onChangePassword}
            //           buttonHasLink={false}
            //           buttonDisabled={isChangePassword}
            //         />
            //       </div>
            //   </div>
            // </div>:
            // <div className="bg-gray-100 ">
            //   <div className="bg-white p-6 mx-auto md:mx-auto">
            //     {
            //       (paymentStatus && paymentStatus === 1) &&
            //       <div className="text-green-600 w-16 h-16 mx-auto my-6 text-6xl flex items-center justify-center">
            //         <i className="fa-solid fa-circle-check"></i>
            //       </div>
            //     }
            //     {
            //       (paymentStatus && paymentStatus === 2) &&
            //       <div className="text-green-600 w-16 h-16 mx-auto my-6 text-6xl flex items-center justify-center">
            //         <i className="fa-solid fa-circle-check"></i>
            //       </div>
            //       // <div className="text-rose-600 w-16 h-16 mx-auto my-6 text-6xl flex items-center justify-center">
            //       //   <i className="fa-solid fa-circle-xmark"></i>
            //       // </div>
            //     }
            //     <div className="text-center">
            //         <h3 className="md:text-2xl text-base text-gray-900 font-semibold text-center">{t('account_activated')}</h3>
            //         <p className="text-gray-600 my-2">{(paymentStatus && paymentStatus === 1)?t('click_the_button_below_to_start_planning'):t('click_the_button_below_to_start_planning')}</p>
            //         <div className="py-10 text-center">
            //           <Button
            //             buttonClasses="mx-auto"
            //             buttonLabelClasses=""
            //             buttonType={"button"}
            //             buttonIcon={(processing)?"fa-light fa-spinner fa-spin":"fa-light fa-arrow-right-to-arc"}
            //             buttonIconPosition={"left"}
            //             buttonLabel={t('get_started')}
            //             functions={checkActivation}
            //             buttonHasLink={false}
            //             buttonDisabled={processing}
            //           />
            //         </div>
            //     </div>
            //   </div>
            // </div>
          }
        </div>
      </div>
    </div>
  );
};

export default Callback;
